import React, { useEffect, useState } from "react";
import { Radio, Space } from "antd";
import "./Filter.css";
import { useSelector } from "react-redux";

export default function FilterConversations(props) {
  const Hrms = useSelector((state) => state.messagesReducer.Hrms);
  const [value, setValue] = useState(props?.counts?.data?.totalConversations);
  const [HRMValue, setHRMValue] = useState(0);
let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  useEffect(() => {
    setHRMValue(props?.IsHrm?.Profiles?.ProfileId);
  }, []);

  const onChangeConversations = (e) => {
    props?.setConversationsRadioValue(e.target.value);
    props?.setConversationsRadioValue(e.target.value);
    // setValue(e.target.value)
  };

  const onChangeHrmFilter = (e) => {
    props?.sethrmId(e.target.value);
    setHRMValue(e.target.value);
  };

  // const onChange = (e: RadioChangeEvent) => {
  //   console.log('radio checked', e.target.value);
  //   setValue(e.target.value);
  // };
  const onChangeVMSFilter = (e) => {
    props?.setVmsId(e.target.value);
  };

  const onChangeBidType = (e) => {
    props?.setBidTypeRadioValue(e.target.value);
  };

  const onChangeBidStatus = (e) => {
    props?.setBidStatusRadioValue(e.target.value);
  };

  function capitalizeFirstLetter(string) {
    try {
      return string?.charAt(0).toUpperCase() + string.slice(1);
    } catch {
      return " ";
    }
  }

  return (
    <div className="employer-filter-container">
      <Radio.Group
        onChange={onChangeConversations}
        value={props?.conversationsRadioValue}
      >
        <Space direction="vertical">
          <Radio
            className="chat-filter-radios"
            value="all_conversations"
            onClick={() => setValue(props?.counts?.data?.totalConversations)}
          >
            <div className="message-filter-options">
              <div>All conversations</div>
            </div>
          </Radio>
          <Radio
            className="chat-filter-radios"
            value="unread"
            onClick={() => setValue(props.counts?.data?.allCount?.unread ?? 0)}
          >
            <div className="message-filter-options">
              <div>Unread</div>
            </div>
          </Radio>
          <Radio
            className="chat-filter-radios"
            value="favourites"
            onClick={() =>
              setValue(props.counts?.data?.allCount?.favorites ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Favorites</div>
              {/* <div>{`(${props.counts?.data?.allCount?.favorites ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
        </Space>
      </Radio.Group>

      <div className="chat-section-header">Bid type</div>
      <Radio.Group onChange={onChangeBidType} value={props.bidTypeRadioValue}>
        <Space direction="vertical">
          <Radio
            value="all_bids"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props.counts?.data?.totalConversations ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>All bids</div>
              {/* <div>{`(${props.counts?.data?.totalConversations ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="placed_bids"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props.counts?.data?.allCount?.PlacedBids ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Place bids</div>
              {/* <div>{`(${props.counts?.data?.allCount?.PlacedBids ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="received_bids"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props.counts?.data?.allCount?.ReceivedBids ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Received bids</div>
              {/* <div>{`(${
                props.counts?.data?.allCount?.ReceivedBids ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
        </Space>
      </Radio.Group>
      <div className="chat-section-header">Filter by bid status</div>
      <Radio.Group
        onChange={onChangeBidStatus}
        value={props.bidStatusRadioValue}
      >
        <Space direction="vertical">
          <Radio className="chat-filter-radios" value="New">
            <div
              className="message-filter-options"
              onClick={() => setValue(props.counts?.data?.allCount?.New ?? 0)}
            >
              {" "}
              <div>New bids</div>
              {/* <div>{`(${props.counts?.data?.allCount?.New ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Accepted"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props.counts?.data?.allCount?.Accepted ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Accepted bids</div>
              {/* <div>{`(${props.counts?.data?.allCount?.Accepted ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Declined"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props.counts?.data?.allCount?.Declined ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Declined bids</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Declined ?? 0})`}</div>{" "} */}
            </div>
          </Radio>

          <Radio
            value="Profile_Submitted"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.ProfileSubmitted ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Profile submitted</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.ProfileSubmitted ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Interview"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.Interview ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Interview</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Interview ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Interview_Accepted"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.InterviewAccepted ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Interview accepted</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.InterviewAccepted ?? 0
              })`}</div> */}{" "}
            </div>
          </Radio>

          <Radio
            value="Interview_Declined"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.InterviewDeclined ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Interview declined</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.InterviewDeclined ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Interview_Cancelled"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.InterviewDeclined ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Interview cancelled</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.InterviewDeclined ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Offer"
            className="chat-filter-radios"
            onClick={() => setValue(props.counts?.data?.allCount?.Offer ?? 0)}
          >
            <div className="message-filter-options">
              {" "}
              <div>Offer sent</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Offer ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Offer_Accepted"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.OfferAccepted ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Offer accepted</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.OfferAccepted ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Offer_Declined"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.OfferDeclined ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Offer declined</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.OfferDeclined ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Hired"
            className="chat-filter-radios"
            onClick={() => setValue(props.counts?.data?.allCount?.Hired ?? 0)}
          >
            <div className="message-filter-options">
              {" "}
              <div>Hired</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Hired ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="On_Billing"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.OnBilling ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>On billing</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.OnBilling ?? 0})`}</div>{" "} */}
            </div>
          </Radio>

          <Radio
            value="Off_Billing"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.OffBilling ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Off biling</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.OffBilling ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Billing_Extend"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.BillingExtend ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Billing extended</div>
              {/* <div>{`(${
                props?.counts?.data?.allCount?.BillingExtend ?? 0
              })`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Canceled"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.Canceled ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Canceled</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Canceled ?? 0})`}</div>{" "} */}
            </div>
          </Radio>

          <Radio
            value="Terminated"
            className="chat-filter-radios"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.Terminated ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Terminated</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Terminated ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
          <Radio
            value="Retracted"
            onClick={() =>
              setValue(props?.counts?.data?.allCount?.Retracted ?? 0)
            }
          >
            <div className="message-filter-options">
              {" "}
              <div>Retracted</div>
              {/* <div>{`(${props?.counts?.data?.allCount?.Retracted ?? 0})`}</div>{" "} */}
            </div>
          </Radio>
        </Space>
      </Radio.Group>
      {Hrms && Hrms?.length > 0 && props?.IsHrm?.MasterAccountId === null && (
        <div>
          <div className="chat-section-header">Filter by HRM</div>
          <Radio.Group value={HRMValue} onChange={onChangeHrmFilter}>
            <Space direction="vertical">
              {/* <Radio  value={''} className="chat-filter-radios">
                {" "}
                <div>
                  {capitalizeFirstLetter(props?.IsHrm?.Profiles?.FirstName) +
                    " " +
                    capitalizeFirstLetter(props?.IsHrm?.Profiles?.LastName)}
                </div>
              </Radio> */}
              {Hrms?.map((items, index) => (
                <Radio
                  key={index}
                  value={items?.AccountId}
                  className="chat-filter-radios"
                >
                  <div className="message-filter-options">
                    {" "}
                    <div>
                      {capitalizeFirstLetter(items?.Profiles?.FirstName) +
                        " " +
                        capitalizeFirstLetter(items?.Profiles?.LastName)}
                    </div>
                  </div>
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </div>
      )}
      {userProfile?.PvtEmpName === "SG-PTM" && props?.vms && props.vms.length > 0 && (
  <div>
    <div className="chat-section-header">Filter by VMS</div>
    <Radio.Group value={props.vmsId} onChange={onChangeVMSFilter}>
      <Space direction="vertical">
        {props.vms.map((item) => (
          <Radio
            key={item._id}
            value={item.VMSLowerName}
            className="chat-filter-radios"
          >
            <div className="message-filter-options">
              <div>{item.VMSName}</div>
            </div>
          </Radio>
        ))}
      </Space>
    </Radio.Group>
  </div>
)}
    </div>
  );
}
